<template>
    <div class="search-tab">
        <el-row class="panel">
            <el-col :span="16">
                <el-radio v-model="radio" v-removeAria label="rangeRadio"><span>{{ $t('T_SEARCH_BY_RANGE') }}</span></el-radio>
                <el-radio v-model="radio" v-removeAria label="textRadio"><span>{{ $t('T_SEARCH_BY_TEXTBOX') }}</span></el-radio>
            </el-col>
            <el-col :span="8" class="btn-right">
                <el-button plain size="mini" class="changeModelBtn" @click="changeModel" v-show="model === 'Imperial'">{{ $t('T_CHANGE_UNIT_TO_IMPERIAL') }}</el-button>
                <el-button plain size="mini" class="changeModelBtn" @click="changeModel" v-show="model !== 'Imperial'">{{ $t('T_CHANGE_UNIT_TO_METRIC') }}</el-button>
            </el-col>
        </el-row>
        <el-row class="panel">
            <el-col :span="6">
                <span class="text-margin title-width" :title="$t('T_INFO_BRIGHTNESS')">{{ $t('T_INFO_BRIGHTNESS') }}</span>
                <el-select v-model="brightnessData" style="width: 152px" v-show="brightnessSelect" @change="changeValue('brightness')" clearable :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')">
                    <el-option v-for="item in brightnessOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <span v-show="!brightnessSelect">
                    <el-input v-model="brightnessMin" @input="testDigital($event, 'brightnessMin')" style="width: 60px" @blur="formatInput('brightnessMin')"></el-input>
                    {{ $t('T_SEARCH_RANGE_TO') }}
                    <el-input v-model="brightnessMax" @input="testDigital($event, 'brightnessMax')" style="width: 60px" @blur="formatInput('brightnessMax')"></el-input>
                    <el-button type="text" @click="backValue('brightness')">lumen</el-button>
                </span>
            </el-col>
            <el-col :span="6">
                <span class="text-margin title-width" :title="$t('T_INFO_RESOLUTION')">{{ $t('T_INFO_RESOLUTION') }}</span>
                <el-select v-model="resolutionData" style="width: 152px" clearable :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')">
                  <el-option v-for="item in resolutionOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-col>
            <el-col :span="6">
              <span class="text-margin title-width" :title="$t('T_INFO_CONTRAST')">{{ $t('T_INFO_CONTRAST') }}</span>
              <el-select v-model="constrastData" style="width: 152px" v-show="constrastSelect" @change="changeValue('constrast')" clearable :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')">
                <el-option v-for="item in constrastOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <span v-show="!constrastSelect">
                <el-input v-model="constrastMin" @input="testDigital($event, 'constrastMin')" style="width: 60px" @blur="formatInput('constrastMin')"></el-input>
                {{ $t('T_SEARCH_RANGE_TO') }}
                <el-input v-model="constrastMax" @input="testDigital($event, 'constrastMax')" style="width: 60px" @blur="formatInput('constrastMax')"></el-input>
                <el-button type="text" @click="backValue('constrast')">:1</el-button>
              </span>
            </el-col>
            <el-col :span="6">
                <span class="text-margin title-width" :title="$t('T_INFO_RESOLUTION')">{{ $t('T_INFO_WEIGHT') }}</span>
                <el-select v-model="weightData" style="width: 152px" v-show="weightSelect" @change="changeValue('weight')" clearable :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')">
                    <el-option v-for="item in weightOptions[weightUnit]" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <span v-show="!weightSelect">
                    <el-input v-model="weightMin" @input="testDigital($event, 'weightMin')" style="width: 60px" @blur="formatInput('weightMin')"></el-input>
                    {{ $t('T_SEARCH_RANGE_TO') }}
                    <el-input v-model="weightMax" @input="testDigital($event, 'weightMax')" style="width: 60px" @blur="formatInput('weightMax')"></el-input>
                    <el-button type="text" @click="backValue('weight')">{{ weightUnit }}</el-button>
                </span>
            </el-col>
        </el-row>
        <el-row class="panel">
            <el-col :span="6">
                <span class="text-margin title-width" :title="$t('T_INFO_FAN_NOISE')">{{ $t('T_INFO_FAN_NOISE') }}</span>
                <el-select v-model="noiseData" style="width: 152px" v-show="noiseSelect" @change="changeValue('noise')" clearable :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')">
                    <el-option v-for="item in noiseOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <span v-show="!noiseSelect">
                    <el-input v-model="noiseMin" @input="testDigital($event, 'noiseMin')" style="width: 60px" @blur="formatInput('noiseMin')"></el-input>
                    {{ $t('T_SEARCH_RANGE_TO') }}
                    <el-input v-model="noiseMax" @input="testDigital($event, 'noiseMax')" style="width: 60px" @blur="formatInput('noiseMax')"></el-input>
                    <el-button type="text" @click="backValue('noise')">dB</el-button>
                </span>
            </el-col>
            <el-col :span="6">
                <span class="text-margin title-width" :title="$t('T_THROW_RATIO')">{{ $t('T_THROW_RATIO') }}</span>
                <el-select v-model="throwRatioData" style="width: 152px" clearable :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')">
                    <el-option v-for="item in throwRatioOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-col>
            <el-col :span="5">
                <span class="text-margin title-width" :title="$t('T_INFO_LIGHT_TYPE')">{{ $t('T_INFO_LIGHT_TYPE') }}</span>
                <el-select v-model="lampTypeData" style="width: 152px" clearable :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')">
                    <el-option v-for="item in lampTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-col>
            <el-col :span="7">
                <span class="text-margin title-width" :title="$t('T_INTERFACE')" style="width: 142px;">{{ $t('T_INTERFACE') }}</span>
                <el-select v-model="interfaceData" style="width: 152px" clearable :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')">
                    <el-option v-for="item in interfaceOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-col>
        </el-row>
        <el-row class="panel">
          <span class="item-margin">
            {{ $t('T_DIMENSION')}}({{ unit === 'mm' ? $t('T_MILLIMETER') : $t('T_INCH') }})
          </span>
          <span class="item-margin">
            <span class="text-margin">{{$t('T_WIDTH')}}</span>
            <el-input v-model="width" @input="testDigital($event, 'width')" style="width: 100px" @blur="formatInput('width')"></el-input>
          </span>
          <span class="item-margin">
            <span class="text-margin">{{$t('T_DEPTH')}}</span>
            <el-input v-model="depth" @input="testDigital($event, 'depth')" style="width: 100px" @blur="formatInput('depth')"></el-input>
          </span>
          <span>
            <span class="text-margin">{{$t('T_HEIGHT')}}</span>
            <el-input v-model="height" @input="testDigital($event, 'height')" style="width: 100px" @blur="formatInput('height')"></el-input>
          </span>
        </el-row>
        <el-row class="panel btn-right">
          <el-button type="button" @click="searchAction">{{ $t('T_SEARCH') }}</el-button>
        </el-row>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import Vue from 'vue'
export default {
  data () {
    return {
      radio: 'rangeRadio',
      options: [{
        label: '_to_lumens',
        value: 'changeTo'
      }],
      model: '',
      width: '',
      height: '',
      depth: '',
      brightnessData: '',
      constrastData: '',
      resolutionData: '',
      weightData: '',
      noiseData: '',
      brightnessSelect: true,
      constrastSelect: true,
      weightSelect: true,
      noiseSelect: true,
      lampTypeData: '',
      throwRatioData: '',
      interfaceData: '',
      brightnessMin: '',
      brightnessMax: '',
      constrastMin: '',
      constrastMax: '',
      weightMin: '',
      weightMax: '',
      weightUnit: 'kgs',
      noiseMin: '',
      noiseMax: '',
      unit: '',
      brightnessOptions: [{
        label: '1000-2000',
        value: '1000-2000'
      }, {
        label: '2001-4000',
        value: '2001-4000'
      }, {
        label: '4001-6000',
        value: '4001-6000'
      }, {
        label: '6001-8000',
        value: '6001-8000'
      }, {
        label: '8001-10000',
        value: '8001-10000'
      }, {
        label: '10001-15000',
        value: '10001-15000'
      }, {
        label: '15001-20000',
        value: '15001-20000'
      }, {
        label: '20001-25000',
        value: '20001-25000'
      }, {
        label: '25001-30000',
        value: '25001-30000'
      }, {
        label: 'Over 30000',
        value: '30000+'
      }, {
        label: '_to_lumens',
        value: 'changeTo'
      }],
      constrastOptions: [{
        label: '-',
        value: '-'
      }, {
        label: '300-1000:1',
        value: '300-1000'
      }, {
        label: '1001-2000:1',
        value: '1001-2000'
      }, {
        label: '2001-3000:1',
        value: '2001-3000'
      }, {
        label: '3001-5000:1',
        value: '3001-5000'
      }, {
        label: '5001-10000:1',
        value: '5001-10000'
      }, {
        label: '10001-20000:1',
        value: '10001-20000'
      }, {
        label: '20001-60000:1',
        value: '20001-60000'
      }, {
        label: '60001-100000:1',
        value: '60001-100000'
      }, {
        label: 'Over 100000:1',
        value: '100000+'
      }, {
        label: '_to_lumens',
        value: 'changeTo'
      }],
      resolutionOptions: [{
        label: 'SVGA　(800 x 600)',
        value: 'SVGA'
      }, {
        label: 'WXGA (1280 x 800)',
        value: 'WXGA'
      }, {
        label: 'SXGA+ (1440  x 1050)',
        value: 'SXGA+'
      }, {
        label: 'WUXGA (1920 x 1200)',
        value: 'WUXGA'
      }, {
        label: 'XGA',
        value: 'XGA'
      }, {
        label: '1080p (1920 x 1080)',
        value: '1080p'
      }, {
        label: '4K (3840 x 2160)',
        value: '4K'
      }],
      weightOptions: {
        kgs: [{
          label: '0-2 kgs',
          value: '0-2'
        }, {
          label: '2-4 kgs',
          value: '2-4'
        }, {
          label: '4-6 kgs',
          value: '4-6'
        }, {
          label: '6-10 kgs',
          value: '6-10'
        }, {
          label: '10-20 kgs',
          value: '10-20'
        }, {
          label: '20+ kgs',
          value: '20+'
        }, {
          label: 'Any Weight',
          value: 'any'
        }, {
          label: '___ to ___ kgs',
          value: 'changeTo'
        }],
        lbs: [{
          label: '0-2 lbs',
          value: '0-2'
        }, {
          label: '2-4 lbs',
          value: '2-4'
        }, {
          label: '4-6 lbs',
          value: '4-6'
        }, {
          label: '6-10 lbs',
          value: '6-10'
        }, {
          label: '10-20 lbs',
          value: '10-20'
        }, {
          label: '20+ lbs',
          value: '20+'
        }, {
          label: 'Any Weight',
          value: 'any'
        }, {
          label: '___ to ___ lbs',
          value: 'changeTo'
        }]
      },
      noiseOptions: [{
        label: '0-22 dB',
        value: '0-22'
      }, {
        label: '22-26 dB',
        value: '22-26'
      }, {
        label: '26-32 dB',
        value: '26-32'
      }, {
        label: '32-40 dB',
        value: '32-40'
      }, {
        label: '40+ dB',
        value: '40+'
      }, {
        label: 'Any Noise Level',
        value: 'any'
      }, {
        label: '___ to ___ dB',
        value: 'changeTo'
      }],
      throwRatioOptions: [{
        label: '0.1 - 0.30',
        value: '0.1-0.30'
      }, {
        label: '0.31 - 0.50',
        value: '0.31-0.50'
      }, {
        label: '0.51 - 1.00',
        value: '0.51-1.00'
      }, {
        label: '1.01 - 1.50',
        value: '1.01-1.50'
      }, {
        label: '1.51 - 2.00',
        value: '1.51-2.00'
      }, {
        label: '2.01 - 3.00',
        value: '2.01-3.00'
      }, {
        label: '3.01 - 5.00',
        value: '3.01-5.00'
      }, {
        label: '5.01 - 7.00',
        value: '5.01-7.00'
      }, {
        label: '7.01 - 10.00',
        value: '7.01-10.00'
      }, {
        label: '10.00 -',
        value: '10.00-'
      }],
      lampTypeOptions: [{
        label: 'Lamp',
        value: 'Lamp'
      }, {
        label: 'Laser',
        value: 'Laser Diode'
      }],
      interfaceOptions: [{
        label: 'HDMI',
        value: 'inputHdmi'
      }, {
        label: 'SDI',
        value: 'SDI'
      }, {
        label: '5BNC',
        value: '5BNC'
      }, {
        label: 'HDBaseT',
        value: 'inputHdBaseT'
      }, {
        label: 'DVI',
        value: 'DVI'
      }, {
        label: 'Computer',
        value: 'inputRgb'
      }, {
        label: 'LAN',
        value: 'inputWiredLan'
      }, {
        label: 'Wireless LAN',
        value: 'inputWirelessLan'
      }, {
        label: 'USB',
        value: 'inputUsbA'
      }]
    }
  },

  computed: {
    ...mapState([
      'searchTabActive',
      'specificationMatchingModelData',
      'unitDataOptions'
    ]),

    initConfig () {
      return Vue.prototype.InitConfig
    }
  },

  watch: {
    radio (value) {
      if (value === 'rangeRadio') {
        this.brightnessSelect = true
        this.constrastSelect = true
        this.weightSelect = true
        this.noiseSelect = true
      } else {
        this.brightnessSelect = false
        this.constrastSelect = false
        this.weightSelect = false
        this.noiseSelect = false
      }
    },
    searchTabActive (val) {
      if (val === 'Specification') {
        this.MATCHINGMODELDATA(this.specificationMatchingModelData)
      }
    }
  },

  mounted () {
    let tempUnit = this.initConfig.initUnit === '' ? 'T_METRE_M' : this.initConfig.initUnit
    let tempSimplify = this.unitDataOptions.filter((item) => {
      return item.value === tempUnit
    })[0].simplify
    this.unit = tempSimplify === 'mm' || tempSimplify === 'm' ? 'mm' : 'inch'
    this.model = this.unit === 'mm' ? 'Imperial' : 'Metric'
  },

  methods: {
    changeModel () {
      this.model = this.model === 'Imperial' ? 'Metric' : 'Imperial'
      this.weightUnit = this.weightUnit === 'kgs' ? 'lbs' : 'kgs'
      this.unit = this.unit === 'mm' ? 'inch' : 'mm'
    },

    changeValue (name) {
      if (this[name + 'Data'] === 'changeTo') {
        this[name + 'Select'] = false
        this[name + 'Data'] = ''
      }
    },

    backValue (name) {
      this[name + 'Select'] = true
      this[name + 'Max'] = ''
      this[name + 'Min'] = ''
    },

    searchAction () {
      let result = []
      // let temp = {}
      this.ProjectorSpec.forEach((item) => {
        // temp[item.resolution] = 1
        if (this.filterProjector(item)) {
          result.push(item)
        }
      })
      if (result.length < 1) {
        this.$message.warning({
          message: this.$t('T_NO_RESULT'),
          duration: 3000
        })
      }
      this.MATCHINGMODELDATA(result)
      this.SPECIFICATIONMATCHINGMODELDATA(result)
    },

    filterProjector (projector) {
      let result = true
      // dimension "440 x 120 x 304 mm"
      let dimension = projector.maxDimension.split('mm')[0].trim().split('x')
      let width = this.width
      let height = this.height
      let depth = this.depth
      if (this.unit !== 'mm') {
        width = (this.$commonJs.changeUnit(this.width, 'T_INCH_DECIMAL', true) * 10).toFixed(0)
        height = (this.$commonJs.changeUnit(this.height, 'T_INCH_DECIMAL', true) * 10).toFixed(0)
        depth = (this.$commonJs.changeUnit(this.depth, 'T_INCH_DECIMAL', true) * 10).toFixed(0)
      }
      if ((this.width && Number(dimension[0].trim()) > Number(width)) || (this.height && Number(dimension[1].trim()) > Number(height)) || (this.depth && Number(dimension[2].trim()) > Number(depth))) {
        result = false
      }
      result = this.checkBirghtness(projector, result)
      result = this.checkConstrast(projector, result)
      result = this.checkWeight(projector, result)
      result = this.checkNoise(projector, result)
      result = this.checkThrowRatio(projector, result)
      result = this.checkInterface(projector, result)
      result = this.checkResolution(projector, result)
      result = this.checkLampType(projector, result)
      return result
    },

    // brightness color
    checkBirghtness (projector, res) {
      let result = res
      if (!result) {
        return false
      }
      if (this.brightnessSelect && this.brightnessData) {
        if (this.brightnessData === '30000+' && projector.color * 1 < 30001) {
          result = false
        }
        if (this.brightnessData !== '30000+') {
          let brightnessRange = this.brightnessData.split('-')
          if (projector.color * 1 < brightnessRange[0] * 1 || projector.color * 1 > brightnessRange[1] * 1) {
            result = false
          }
        }
      }
      if (!this.brightnessSelect) {
        result = this.$commonJs.matchRange(projector.color, this.brightnessMax, this.brightnessMin)
      }
      return result
    },

    // contrast
    checkConstrast (projector, res) {
      let result = res
      if (!result) {
        return false
      }
      if (this.constrastSelect && this.constrastData) {
        if (this.constrastData === '100000+' && (projector.contrast.split(':')[0] * 1 < 100001 || projector.contrast === '-')) {
          result = false
        }
        if (this.constrastData !== '100000+') {
          let constrastRange = this.constrastData.split('-')
          let constrast = projector.contrast.split(':')[0] * 1
          if (this.constrastData === '-' && projector.contrast === '-') {
            result = true
          } else {
            if (constrast < constrastRange[0] * 1 || constrast > constrastRange[1] * 1 || projector.contrast === '-') {
              result = false
            }
          }
        }
      }
      if (!this.constrastSelect) {
        result = this.$commonJs.matchRange(projector.contrast, this.constrastMax, this.constrastMin)
      }
      return result
    },

    // weight weightIncludingLens 58 lbs / 26 kg
    checkWeight (projector, res) {
      let result = res
      if (!result) {
        return false
      }
      if (this.weightSelect && this.weightData && this.weightData !== 'any') {
        let weight = this.getWeight(projector)
        if (this.weightData === '20+' && weight * 1 < 20) {
          result = false
        }
        if (this.weightData !== '20+') {
          let weightRange = this.weightData.split('-')
          if (weight < weightRange[0].trim() * 1 || weight > weightRange[1].trim() * 1) {
            result = false
          }
        }
      }
      if (!this.weightSelect) {
        let weight = this.getWeight(projector)
        result = this.$commonJs.matchRange(weight, this.weightMax, this.weightMin)
      }
      return result
    },

    // noise fanNoise
    checkNoise (projector, res) {
      let result = res
      if (!result) {
        return false
      }
      if (this.noiseSelect && this.noiseData && this.noiseData !== 'any') {
        let noise = projector.fanNoise.split('dB')[0].trim()
        if (this.noiseData === '40+' && noise * 1 < 41) {
          result = false
        }
        if (this.noiseData !== '40+') {
          let noiseRange = this.noiseData.split('-')
          if (noise < noiseRange[0].trim() * 1 || noise > noiseRange[1].trim() * 1) {
            result = false
          }
        }
      }
      if (!this.noiseSelect) {
        let noise = projector.fanNoise.split('dB')[0].trim()
        result = this.$commonJs.matchRange(noise, this.noiseMax, this.noiseMin)
      }
      return result
    },

    // lamp type lightType : lamp Laser Diode
    checkThrowRatio (projector, res) {
      let result = res
      if (!result) {
        return false
      }
      if (this.throwRatioData) {
        var { matchingLensID, selectedLensInfo } = this.$commonJs.findLensInfo(projector)
        let realThrowRatio = (selectedLensInfo.throwRatio || '').split('-')
        if (this.throwRatioData === '10-' && realThrowRatio[0].trim() * 1 > 10) {
          return result
        }
        let ratio = this.throwRatioData.split('-')
        // 只比较最小值
        if (ratio[0] * 1 >= realThrowRatio[0].trim() * 1 || ratio[1] * 1 <= realThrowRatio[0].trim() * 1) {
          // 检测可选镜头有没有匹配的
          if (!this.comparenLesThrowratio(matchingLensID, projector.lcdSize, ratio)) {
            result = false
          }
        }
      }
      return result
    },

    comparenLesThrowratio (matchingLensID, lcdSize, target) {
      let result = false
      for (let i = 0; i < matchingLensID.length; i++) {
        if (result) {
          break
        }
        let lensData = this.OptionLensSpec.filter((item) => {
          return item.id === matchingLensID[i] && item.lcdSize === lcdSize
        })
        if (lensData.length < 1) break
        let temp = lensData[0].throwRatio.split('-')
        if (temp[0].trim() * 1 >= target[0] * 1 && !target[1]) {
          this.SET_THROWDISTANCE2SCREENSIZWIDTH(target)
          result = true
          break
        } else if (temp[0].trim() * 1 >= target[0] * 1 && target[1] && temp[0].trim() * 1 <= target[1] * 1) {
          this.SET_THROWDISTANCE2SCREENSIZWIDTH(target)
          result = true
          break
        }
      }
      return result
    },

    // interface
    checkInterface (projector, res) {
      let result = res
      if (!result) {
        return false
      }
      if (this.interfaceData) {
        let interfaceValue = projector[this.interfaceData]
        if (!interfaceValue || interfaceValue === '-') {
          result = false
        }
      }
      return result
    },

    // resolution
    checkResolution (projector, res) {
      let result = res
      if (!result) {
        return false
      }
      if (this.resolutionData) {
        let resolution = projector.resolution
        if (this.resolutionData === '1080p' && (resolution !== '1080p' || resolution !== 'FWXGA' || resolution !== 'Full HD')) {
          result = false
        }
        if (this.resolutionData !== '1080p' && this.resolutionData !== resolution) {
          result = false
        }
        if (this.resolutionData === '1080p' && resolution === '1080p') {
          result = true
        }
      }
      return result
    },

    // lamp type
    checkLampType (projector, res) {
      let result = res
      if (!result) {
        return false
      }
      if (this.lampTypeData) {
        let lightType = projector.lightType
        if (lightType.indexOf(this.lampTypeData) < 0) {
          result = false
        }
      }
      return result
    },

    getWeight (projector) {
      let weightLbs = projector.weightIncludingLens.split('/')[0].split('lbs.')[0]
      if (weightLbs.indexOf('Approx.') > -1) {
        weightLbs = weightLbs.split('Approx.')[1].trim()
      } else {
        weightLbs = weightLbs.split('Under')[1].trim()
      }
      let weightKg = projector.weightIncludingLens.split('/')[1].toLowerCase().split('kg')[0].trim()
      return this.weightUnit === 'kgs' ? weightKg : weightLbs
    },

    testDigital (e, key) {
      e = e.replace(/[^0-9|.]/ig, '')
      let n = (this[key].split('.') || [ ]).length - 1
      if (n > 1) {
        e = ''
      }
      this[key] = e
    },

    formatInput (key) {
      if (this[key] === '') {
        return
      } else if (isNaN(this[key])) {
        this[key] = '0'
      }
      this[key] = (this[key] * 1).toFixed(1) * 1
    },

    ...mapMutations([
      'MATCHINGMODELDATA',
      'SET_THROWDISTANCE2SCREENSIZWIDTH',
      'SPECIFICATIONMATCHINGMODELDATA'
    ])
  }
}
</script>
<style scoped>
  .appContent {
    padding-bottom: 20px;
  }

  .title-width {
    text-align: right;
    margin-right:10px;
    width: 90px;
    line-height: 12px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
    top: 2px;
  }
  .changeModelBtn{
    width: auto!important;
    padding: 5px!important;
  }
</style>



// WEBPACK FOOTER //
// src/view/searchTabs/specification.vue